import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, BookOpen, Radio, FileText, User, Repeat, Wallet, Landmark } from "lucide-react";

const nav = [
  { to: "/educator", label: "Dashboard", icon: LayoutDashboard },
  { to: "/educator/courses", label: "My Courses", icon: BookOpen },
  { to: "/educator/live", label: "Live Classes", icon: Radio },
  { to: "/educator/tests", label: "Tests", icon: FileText },
  { to: "/educator/earnings", label: "Earnings", icon: Wallet },
  { to: "/educator/bank", label: "Bank & Withdrawals", icon: Landmark },
  { to: "/educator/subscription", label: "Educator Plan", icon: Repeat },
  { to: "/learner/profile", label: "Profile", icon: User },
];

export default function EducatorLayout() {
  return <DashboardLayout nav={nav} title="Educator Portal" />;
}
